module.exports = __webpack_public_path__ + "img/LanEn_background.69945951.png";